import React, { Component } from 'react';
import { Redirect, withRouter, Link } from 'react-router-dom';
import pkceChallenge from 'pkce-challenge';
import axios from "axios";

import TopBar from './../../TopBar';
import Footer from './../../Footer';
import { Row, Col } from 'reactstrap';

import {
  _setSSOToken,
  decodeIdToken
} from './ssoutils';


export default withRouter(class HowardHanna extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authenticated: null,
      fetchInProgress: false,
      authToken: false,
      error: false,
      errorMessage: false
    };
  }

  componentDidMount() {
    const url = window.location.href;

    if (url.includes('dashboard')) {
      // Initiate PKCE flow → redirect to Okta
      const codes = pkceChallenge();
      sessionStorage.setItem('code_challenge', codes.code_challenge);
      sessionStorage.setItem('code_verifier', codes.code_verifier);

      const authUrl =
        `${process.env.HOWARDHANNA_BASE_URL}oauth2/v1/authorize?` +
        `client_id=${process.env.HOWARDHANNA_CLIENT_ID}` +
        `&redirect_uri=${encodeURIComponent(process.env.HOWARDHANNA_REDIRECT_URI)}` +
        `&response_type=code` +
        `&scope=openid%20profile%20email` +
        `&state=hhnyc_sso` +
        `&code_challenge=${codes.code_challenge}` +
        `&code_challenge_method=S256` +
        `&response_mode=query`;

      window.location.href = authUrl;

    } else if (url.includes('sso')) {
      // Callback: exchange code for tokens
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      const error = params.get('error');
      const errorDescription = params.get('error_description');

      if (error) {
        const message = errorDescription
          ? decodeURIComponent(errorDescription.replace(/\+/g, ' '))
          : 'Authorization failed, please contact your support team.';
        this.setState({ error, errorMessage: message });
      } else if (code) {
        this._getAuthToken({ code });
      }

    } else {
      // Login page: check for error params
      const query = window.location.search.replace('?', '');
      const hashObject = query.split('&').reduce((res, item) => {
        const parts = item.split('=');
        res[parts[0]] = parts[1];
        return res;
      }, {});

      if (hashObject['error']) {
        const message = hashObject['error_description']
          ? decodeURIComponent(hashObject['error_description'].replace(/\+/g, ' '))
          : 'Authorization failed, please contact support.';
        this.setState({ error: hashObject['error'], errorMessage: message });
      }
    }
  }

  _getAuthToken = ({ code }) => {
    if (!this.state.fetchInProgress) {
      this.setState({ fetchInProgress: true });
    }

    const params = new URLSearchParams();
    params.append('client_id', process.env.HOWARDHANNA_CLIENT_ID);
    params.append('redirect_uri', process.env.HOWARDHANNA_REDIRECT_URI);
    params.append('grant_type', 'authorization_code');
    params.append('code', code);
    params.append('code_verifier', sessionStorage.getItem('code_verifier'));

    axios.post(`${process.env.HOWARDHANNA_BASE_URL}oauth2/v1/token`, params)
      .then((res) => {
        if (res.data && res.data.id_token) {
          const decodedClaims = decodeIdToken(res.data.id_token);
          res.data.claims = decodedClaims;
          _setSSOToken(res.data, 'HOWARDHANNA');
          this.setState({ authToken: res.data });
        }
      })
      .catch((error) => {
        console.log('HowardHanna token exchange error:', error);
        this.setState({
          error: 'token_error',
          errorMessage: 'Sign in failed. Please try again or contact support.'
        });
      });
  }

  render() {
    const { authToken, error, errorMessage } = this.state;

    if (authToken) {
      return <Redirect to={{ pathname: '/dashboard' }} />;
    }

    if (window.location.href.includes('sso') && !error) return null;

    return (
      <div className="plan__wrapper share__wrapper">
        <Row className="login-container login">
          <Col lg={12} className="pt-0 signin">
            <div className="widget-container login hhnyc">
              <div className="sso-logo-container">
                <div className="sso-logo" />
              </div>
              {error && (
                <div className="sub-text mt-3" style={{ color: '#F53246', fontSize: 16, padding: '0 20px' }}>
                  {errorMessage}
                </div>
              )}
              <h4 className="text-center mt-5 mb-2">Howard Hanna NYC Login</h4>
              <div className="sub-text">Howard Hanna NYC agents only.</div>
              <div>You will be redirected to sign in using your Howard Hanna credentials.</div>
              <Link className="mt-5 button" to="/dashboard/hhnyc">
                Sign In
              </Link>
              <p className="disclaimer">
                By signing in, you agree to our{' '}
                <a href="https://marketproof.com/terms-of-use" target="_blank" rel="noreferrer">Terms of Service</a>
                {' '}and{' '}
                <a href="https://marketproof.com/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a>.
              </p>
            </div>
          </Col>
        </Row>
        <Footer />
      </div>
    );
  }
});
